import { useTranslation } from 'react-i18next';
import { Info } from 'lucide-react';

import { resolveDiagnosisRelationshipBadge } from 'widgets/results/diagnosis.utils';
import { Tooltip, TooltipContent, TooltipTrigger } from '@shadcn/components/ui/tooltip';
import { DiagnosisRelationshipBadgeItem } from 'widgets/results/DiagnosisSection/DiagnosisRelationshipBadge.styles';
import type { DiagnosedIcd } from 'types/result';
import { MASKED_TEXT_CLASS } from 'analytics';

type DiagnosisRelationshipBadgeProps = {
  diagnosedIcd: DiagnosedIcd;
};
export function DiagnosisRelationshipBadge({ diagnosedIcd }: DiagnosisRelationshipBadgeProps) {
  const relationshipBadge = resolveDiagnosisRelationshipBadge(diagnosedIcd);
  const { t } = useTranslation();

  if (!relationshipBadge) {
    return null;
  }

  const badge = (
    <DiagnosisRelationshipBadgeItem $variant={relationshipBadge.variant}>
      {t(`result.diagnosisSection.relationship.${relationshipBadge.translationKey}`, {
        code: relationshipBadge.matchedExistingCode ?? '',
      })}
      {relationshipBadge.tooltipKey ? <Info className="h-3 w-3" aria-hidden="true" /> : null}
    </DiagnosisRelationshipBadgeItem>
  );

  return relationshipBadge.tooltipKey ? (
    <Tooltip>
      <TooltipTrigger asChild>{badge}</TooltipTrigger>
      <TooltipContent className={`max-w-xs ${MASKED_TEXT_CLASS}`}>
        {t(`result.diagnosisSection.relationship.${relationshipBadge.tooltipKey}`, {
          code: relationshipBadge.matchedExistingCode ?? '',
        })}
      </TooltipContent>
    </Tooltip>
  ) : (
    badge
  );
}
